import { useEffect } from 'react'
import { useConsent } from '../consent/ConsentContext'
import { disableAnalytics, enableAnalytics } from './analytics'

/**
 * Synchronise la finalité « mesure d'audience » vers la façade. Monté une fois
 * dans `App`.
 *
 * La dépendance ne va que dans un sens : c'est ce hook qui observe le
 * consentement, `ConsentContext` n'apprend jamais l'existence de PostHog.
 *
 * Au premier rendu sans accord, `disableAnalytics()` est appelée alors que rien
 * n'a été déposé — sans effet, la purge étant idempotente, et c'est exactement
 * le raisonnement que `ConsentContext` tient déjà pour son propre appel.
 */
export function useAnalyticsConsent() {
  const { purposes } = useConsent()

  useEffect(() => {
    if (purposes.analytics) enableAnalytics()
    else disableAnalytics()
  }, [purposes.analytics])
}
